(function ($) {

  // ---------- APP START
  var App = {
    config: {
      scrollOffset: 130,
      scrollOffsetDesktop: 250
    },

    init: function () {
      // Init SVG polyfill
      if (typeof (svg4everybody) !== 'undefined') svg4everybody();

      // Init object-fill polyfill
      if (typeof (objectFitImages) !== 'undefined') objectFitImages();

      // Remove focus state when clicking on a button with a mouse
      $(':not(form) button, a').on('click', function (e) {
        if (e.clientX && e.clientY)
          $(this).trigger('blur');
      });
      $('a[href^="#"]:not([href="#rgpd"])').on('click', function (e) {
        e.preventDefault();

        var scrollTo = $(this).data('scroll-to') ? $(this).data('scroll-to') : $(this).attr('href');

        if ($(scrollTo).length > 0 && $(this).data('prevent-scroll') !== true)
          App.scroll(scrollTo, $(this).data('scroll-offset'));
      });

      if ($('[data-scroll]').length) {
        App.scroll($('[data-scroll]').data('scroll'));
      }

      if ($('.header').length) {
        App.menuBurger();
      }
      if ($('.page-header').length) {
        App.fixPageHeader();
      }
      $('select').select2({
        minimumResultsForSearch: Infinity
      });

      if ($('input[name="token"]').length){
        $('input[name="token"]').val($('meta[name="refresh"').attr('content'));
      }

      // Accessibility
      var accessibility = App.readCookie('accessibility');
      if (accessibility == 'on'){
        $('html').addClass('m--access');
      }
      $('.access-btn-js').on('click', App.accessibility);
      App.phonePopin();
      if ($('.home-header').length) {
        App.initHomeHeader();
      }

      if ($('.steps').length) {
        App.initSteps();
      }

      if ($('.flip-cards').length) {
        App.initFlipCards();
      }

      if ($('.testimonies__slider').length) {
        App.initTestimoniesSlider();
      }

      if ($('.agenda__slider').length) {
        App.initAgendaSlider();
      }

      if ($('.image-slider__slider').length){
        App.initImagesSlider();
      }

      if ($('.blog-filters').length){
        App.initBlogFilters();
      }

      App.formTracking();

    },
    scroll: function (element, offset) {
      offset = offset === undefined ? ($(window).width() >= 960 ? App.config.scrollOffsetDesktop : App.config.scrollOffset) : offset;

      $('html, body').animate({
        scrollTop: $(element).offset().top - offset
      }, 'slow');
    },

    menuBurger: function () {
      var $burger = $('.header__burger');
      var $header = $('.header');
      $burger.on('click', function () {
        $header.toggleClass('menu-is-opened');
      });
    },

    accessibility: function(){
      var $html = $('html');
      if ($html.hasClass('m--access')){
        $html.removeClass('m--access');
        App.createCookie('accessibility','off', 7);
      }
      else{
        $html.addClass('m--access');
        App.createCookie('accessibility','on', 7);
      }
      // For steps
      $(window).trigger('resize');
    },
  
    createCookie: function(name,value,days) {
      var expires ='';
      if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toGMTString();
      }
      else expires = "";
      document.cookie = name+"="+value+expires+"; path=/";
    },
  
    readCookie: function(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
    },
  
    eraseCookie: function(name) {
      createCookie(name,"",-1);
    },

    phonePopin: function(){
      $('#phone-btn-js').on('place-popin', function(){
        var $arrow = $('#phone-popin-js').find('.hphone__popin-arrow');
        if ($(window).width() >= 768){
          $('#phone-popin-js').css('left', 'auto');
          $arrow.css('left', '');

        } else {
          $('#phone-popin-js').offset({left: $(window).width()/10});
          $arrow.offset({ left: $('#phone-btn-js').offset().left + $('#phone-btn-js').width()/2 - $arrow.width()/2});
        }
      });
      $('#phone-btn-js').on('mouseenter', function(){
        $(this).addClass('is-opened');
        $('#phone-popin-js').trigger('place-popin');
      });
      $('#phone-btn-js').on('mouseleave', function(){
        $(this).removeClass('is-opened');
      });
      $('#phone-btn-js').on('click', function(){
        $('#phone-btn-js').toggleClass('is-opened');
        $('#phone-popin-js').trigger('place-popin');
      });
      $(window).on('resize', function(){
        $('#phone-btn-js').trigger('place-popin');
      });
      $('#phone-btn-js').trigger('place-popin');
    },

    fixPageHeader: function(){
      $(window).on('scroll', function(){
        window.requestAnimationFrame(function(){
          var $page_header = $('.page-header');
          var page_header_height = 0;
          if ($(window).width() > 960){
            if (!$page_header.hasClass('is-fixed')){
              if ($(window).scrollTop() > ($page_header.offset().top + $page_header.height())){
                $page_header.addClass('is-fixed-soon');
                $page_header.css('top', $('.header').height()-$page_header.outerHeight());
                $page_header.addClass('is-fixed').removeClass('is-fixed-soon');
                page_header_height = $page_header.height();
              }
            }
            else{
              if ($(window).scrollTop() < ($('.header').height() + page_header_height)){
                $page_header.removeClass('is-fixed').removeClass('is-fixed-soon');
                $page_header.css('top', '');
              }
            }
          }
          else{
            $page_header.css('top', '');
          }
        });
      });
    },

    initHomeHeader: function(){
      var $home_header = $('.home-header');
      var height_dynamic = 0;
      $home_header.find('.hh__dynamic-item').each(function(){
        height_dynamic = Math.max(height_dynamic, $(this).height());
      });
      height_dynamic = height_dynamic/parseInt($('html').css('font-size'));
      $home_header.find('.hh__dynamic').css('min-height', height_dynamic+'rem');
      setInterval(function(){
        var $current_item = $home_header.find('.hh__dynamic-item.m--active');
        var $next_item = $current_item.next('.hh__dynamic-item');
        if ($next_item.length){
          $current_item.removeClass('m--active');
          $next_item.addClass('m--active');
        }
        else{
          $current_item.removeClass('m--active');
          $home_header.find('.hh__dynamic-item').first().addClass('m--active');
        }
      }, 3000);
    },

    initSteps: function(){
      $(window).on('resize', function(){
        $('.step__number').each(function(index){
          var height = $(this).height()/$(this).width()*1000;
          $(this).css('background-color', 'transparent');
          $(this).find('.step__svg').html('<svg viewBox="0 0 1000 '+height+'"><polygon points="0 0, '+(index != 0 ? '500 280, ' : '')+'1000 0, 1000 '+(height-280)+', 500 '+height+', 0 '+(height-280)+'" fill=currentColor stroke-width="0"></polygon><polygon points="52 100, '+(index != 0 ? '500 358, ' : '')+'948 100, 948 '+(height-320)+', 500 '+(height-64)+', 52 '+(height-320)+'" fill="none" stroke="#FFF" stroke-width="24"></polygon></svg>');
        });
      });
      $(window).trigger('resize');
    },

    initFlipCards: function(){
      $(window).on('resize', function(){
        $('.flip-cards').each(function(){
          $(this).find('.fc__card-front, .fc__card-back').css('height', 'auto');
          var height = 0;
          $(this).find('.fc__card').each(function(){
            height = Math.max(height, $(this).find('.fc__card-front').outerHeight(), $(this).find('.fc__card-back').outerHeight());
          });
          $(this).find('.fc__card').each(function(){
            $(this).height(height);
          });
          $(this).find('.fc__card-front, .fc__card-back').css('height', '100%');
        });
      });
      $(window).trigger('resize');
      $('.fc__card').on('click', function(){
        if ($(this).hasClass('is-flipped')){
          $(this).removeClass('is-flipped');
        }
        else{
          $(this).parent().find('.fc__card.is-flipped').removeClass('is-flipped');
          $(this).addClass('is-flipped');
        }
      });
      $('.fc__card').on('mouseenter', function(){
        $(this).parent().find('.fc__card.is-flipped').removeClass('is-flipped');
      });
    },

    initTestimoniesSlider: function(){
      $('.testimonies__slider').each(function(){
        var $slider = $(this);
        $slider.slick({
          prevArrow: $slider.parent().find('.testimonies__arrows .slick-prev'),
          nextArrow: $slider.parent().find('.testimonies__arrows .slick-next'),
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        });
      });
    },

    
    initAgendaSlider: function(){
      $('.agenda__slider').each(function(){
        var $slider = $(this);
        $slider.slick({
          prevArrow: $slider.parent().find('.agenda__arrows .slick-prev'),
          nextArrow: $slider.parent().find('.agenda__arrows .slick-next'),
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1260,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            },
          ] 
        });
      });
    },


    initImagesSlider: function(){
      $('.image-slider__slider').each(function(){
        var $slider = $(this);
        $slider.slick({
          prevArrow: $slider.parent().find('.image-slider__arrows .slick-prev'),
          nextArrow: $slider.parent().find('.image-slider__arrows .slick-next'),
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 4,
          responsive: [
            {
              breakpoint: 1260,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            },
          ] 
        });
      });
    },

    initBlogFilters: function(){
      $('.blog-filters select').on('change', function(){
        window.location.href = $(this).val(); 
      });
    },

    formTracking: function() {
      if (typeof(_paq) != undefined){
        if ($('.contact-form').length){
          if ($('.alert.success > p').text()) {
            _paq.push(['trackEvent', 'formulaire', 'formulaire-contact', 'formulaire-contact-OK']);
          }
        }

        $('.newsletter-form-js').each(function(){
          // We're trying to avoid robots here...
          var $this= $(this);
          $this.attr('action', $this.attr('action')+$this.data('token'));
          $this.data('token', '');
          $this.on('submit', function(){
            _paq.push(['trackEvent', 'formulaire', 'formulaire-newsletter', 'formulaire-newsletter-OK']);
          });
        });
      }
    }
  };
  // ---------- APP END

  // Init app
  $(document).ready(App.init);
  window.App = App;

})(jQuery);

// ---------- Matomo Code
var _paq = window._paq || [];
_paq.push(['trackPageView']);
_paq.push(['enableLinkTracking']);
(function () {
  var u = 'https://analytics.addviso.com/';
  _paq.push(['setTrackerUrl', u + 'matomo.php']);
  _paq.push(['setSiteId', 12]);
  var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
  g.type = 'text/javascript'; g.async = true; g.defer = true; g.src = u + 'matomo.js'; s.parentNode.insertBefore(g, s);
})();